import { STORAGE_TYPE } from './storageType';

export const addressTypesWithoutPossibilityAddCustomAddress = [
   STORAGE_TYPE.CLIENT,
   STORAGE_TYPE.INTERNAL,
   STORAGE_TYPE.EXTERNAL,
];
